import { render, staticRenderFns } from "./AccountDialog.vue?vue&type=template&id=4937ca04&"
import script from "./AccountDialog.vue?vue&type=script&lang=js&"
export * from "./AccountDialog.vue?vue&type=script&lang=js&"
import style0 from "./AccountDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports